<template>
  <div>
    <el-card>
      <div style="display: flex">
        <div style="width: 50%">
          <el-row>
            <el-col v-if="isShow">
              <el-button :disabled="editFlag || rfid_perm_status == 0 ? true : false" size="small" type="warning" @click="stprEdit"
                >编辑</el-button
              >
            </el-col>
            <el-col v-else>
              <el-button size="small" type="primary" @click="submit()">保存</el-button>
              <el-button size="small" @click="closeEdit">取消</el-button>
            </el-col>
          </el-row>
          <el-form ref="compRef" :disabled="isShow" :model="prop" :rules="PropRules" label-width="100px" size="small">
            <el-row>
              <el-col :md="12">
                <el-form-item label="复合数量：" prop="rfid_comp_phr">
                  <el-input v-model="prop.rfid_comp_phr" maxlength="11" show-word-limit @input="compPhrChange">
                    <template slot="append">米</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="12">
                <el-form-item label="参与复合人：" prop="rfid_take_stff_names">
                  <el-select v-model="prop.rfid_take_stff_names" multiple placeholder="请选择" @change="compPhrChange2">
                    <el-option v-for="item in stffList" :key="item.stff_name" :label="item.stff_name" :value="item.stff_name"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="12">
                <el-form-item label="填卡人：" prop="card_user_id">
                  <el-select v-model="prop.card_user_id" filterable placeholder="请选择">
                    <el-option v-for="item in stffList" :key="item.user_id" :label="item.stff_name" :value="item.user_id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div>
          <el-form :disabled="isShow" label="right" label-width="100px">
            <el-row>
              <el-form-item label="制作人：" size="small">
                <el-select
                  v-model="prop.stff_id"
                  :disabled="!['徐礼明', '盖新', 'Admin'].includes($cookies.get('userInfo').stff_name)"
                  filterable
                  placeholder="请选择"
                  @change="
                    val => {
                      const find = processList.find(item => item.value === val).o;
                      prop.user_id = find.user_id;
                      prop.stff_name = find.stff_name;
                    }
                  "
                >
                  <el-option v-for="item in processList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="岗位：" size="small">
                <el-input :value="prop.user_jobs" disabled show-word-limit></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="难度系数：" size="small">
                <el-input :value="prop.price" disabled show-word-limit></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item>
                <SubTable2 ref="subTable" :isShow="isShow" :stffList="processList" />
              </el-form-item>
            </el-row>
          </el-form>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { post } from '@api/request';
import { spocAPI } from '@api/modules/spoc';
import helper from '@assets/js/helper';
import SubTable2 from '@/views/DevelopManagement/SmplManage/TabChild/Componet/TabPanel/subTable/subTable2';

export default {
  components: { SubTable2 },
  data() {
    return {
      isShow: true,
      PropRules: {
        rfid_comp_phr: [
          {
            required: true,
            message: '请输入复合用量',
            trigger: 'blur'
          },
          {
            pattern: /^\d{0,6}(\.\d{1,4})?$/,
            message: '最大只能输入999999.9999且最多4位小数!'
          }
        ]
      }
    };
  },
  props: {
    prop: Object,
    rfid_perm_status: Number,
    rfid_Info: Object,
    editFlag: Boolean,
    mainIsShow: Boolean,
    originalComp: Object,
    stffList: Array,
    processList: Array
  },
  created() {},
  methods: {
    btn() {
      console.log(this.prop.rfid_comp_phr);
    },
    submit() {
      this.$refs['compRef'].validate(valid => {
        if (valid) {
          this.$confirm('此操作将保存修改, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(res => {
              let editBody = {};
              editBody = JSON.parse(JSON.stringify(this.prop));
              editBody.list = this.$refs.subTable.tableData.filter(x => (x.rfid_comp_id ? true : !x.rfid_comp_id && !x.destroy_flag));
              if (!editBody.rfid_id) {
                editBody.rfid_id = this.rfid_Info.rfid_id;
                editBody.user_id = this.rfid_Info.user_id;
                editBody.stff_name = this.rfid_Info.stff_name;
                editBody.stff_id = this.rfid_Info.stff_id;
              }
              post(spocAPI.edit_comp, editBody)
                .then(res => {
                  if (res.data.code == 0) {
                    this.$message.success(res.data.msg);
                    //  this.originalComp.rfid_comp_phr =  this.prop.rfid_comp_phr
                    this.$emit('copyComp', this.prop);
                  } else {
                    this.$message.error(res.data.msg);
                  }
                  this.$emit('del');
                })
                .catch(res => {
                  this.$message.error(res.data.msg);
                });

              this.isShow = true;
            })
            .catch(res => {});
        }
      });
    },
    stprEdit() {
      this.$emit('num');
      this.isShow = false;
    },
    closeEdit() {
      this.$confirm('此操作将取消修改, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(res => {
          this.isShow = true;
          this.$message.info('已取消修改');
          this.$emit('del');
          this.prop.rfid_comp_phr = this.originalComp.rfid_comp_phr;
          this.prop.rfid_take_stff_names = this.originalComp.rfid_take_stff_names;
        })
        .catch(res => {});
    },
    compPhrChange(val) {
      val = this.keepNum99(val);
      this.$emit('compPhrChange', val);
    },
    compPhrChange2(val) {
      val = this.keepNum99(val);
      this.$emit('compPhrChange2', val);
    },
    keepNum99(val) {
      let keepTNum = helper.keepTNum1(val);
      if (keepTNum > 99) {
        this.$message.warning('输入范围0～99超出最大限度');
        return 99;
      } else {
        return keepTNum;
      }
    }
  },
  watch: {
    'prop.list'(newValue, oldValue) {
      this.$refs.subTable.tableData = newValue;
    }
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
</style>
